export function isPromise(p) {
    return p?.then != null;
}
//# sourceMappingURL=type-guards.js.map